const updates = [
  { date: '2026-07-31', tag: '上新', title: '本周热门专题全新上线，91免费视频网站频道重磅更新', desc: '数十部精选资源同步入驻，涵盖多元题材，免费高清视频在线即刻畅享。' },
  { date: '2026-07-29', tag: '推荐', title: '91福利在线视频频道播放量突破新高', desc: '热门内容持续火爆，在线免费视频网站用户活跃度再创新纪录。' },
  { date: '2026-07-27', tag: '优化', title: '平台播放体验全面升级，免费视频在线观看更流畅', desc: '服务器全面扩容，峰值时段91在线观看视频网站依旧稳定不缓冲。' },
  { date: '2026-07-25', tag: '上新', title: '91免费在线视频专题「夏日特辑」火热发布', desc: '精选夏季最受欢迎题材，免费高清视频在线随时观看，不要错过。' },
  { date: '2026-07-22', tag: '公告', title: '91麻豆免费视频网站用户协议与社区规范更新', desc: '为保障健康社区环境，平台规则已优化，建议所有用户查阅了解。' },
  { date: '2026-07-20', tag: '推荐', title: '91福利视频在线频道内容大扩容', desc: '新增数百部优质资源，免费视频在线观看选择更多，精彩不断。' },
  { date: '2026-07-18', tag: '优化', title: '移动端观看体验全面提升，随时随地畅享高清', desc: '适配主流移动设备，91在线观看视频网站移动端流畅度大幅改善。' },
  { date: '2026-07-15', tag: '上新', title: '月度精选合集上线，91免费视频网站热门榜同步发布', desc: '综合播放量与用户评分，精选本月最受欢迎内容，一网打尽。' },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 text-center mb-2">最新动态</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">平台更新快讯，随时随地掌握91免费视频网站最新内容</p>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px"></div>
          <div className="space-y-8">
            {updates.map((item, i) => (
              <div key={i} className={`relative flex items-start gap-6 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right md:pr-10' : 'md:text-left md:pl-10'} pl-12 md:pl-0`}>
                  <div className={`inline-flex items-center gap-2 mb-2 ${i % 2 === 0 ? 'md:justify-end' : ''}`}>
                    <span className={`text-xs font-medium px-2.5 py-0.5 rounded-full ${
                      item.tag === '上新' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '推荐' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '优化' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-background-200 text-foreground-600'
                    }`}>{item.tag}</span>
                    <span className="text-xs text-foreground-500">{item.date}</span>
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
                <div className="hidden md:flex flex-1"></div>
                <div className="absolute left-0 md:left-1/2 top-1 w-8 h-8 rounded-full bg-primary-500 -translate-x-1/2 flex items-center justify-center z-10">
                  <i className="ri-circle-fill text-white text-[8px]"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}